import { useState } from 'react';
import { ContactFormData } from '../../types/dealership';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { SuccessModal } from './SuccessModal';


interface ContactUsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ContactUsModal({ isOpen, onClose }: ContactUsModalProps) {
  // const { t } = useLanguage(); // TODO: Implement translations
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState<ContactFormData>({
    fullName: '',
    emailAddress: '',
    phoneNumber: '',
    message: ''
  });

  const handleInputChange = (field: keyof ContactFormData, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSend = () => {
    if (!formData.fullName || !formData.emailAddress || !formData.message) {
      alert('Please fill in all required fields');
      return;
    }
    console.log('Sending contact form:', formData);
    setShowSuccess(true);
  };

  const handleClose = () => {
    setShowSuccess(false);
    setFormData({
      fullName: '',
      emailAddress: '',
      phoneNumber: '',
      message: ''
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
      <Card className="w-full max-w-md bg-white border-2 border-[#f91bdc]">
        <CardHeader className="text-center pb-4">
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <CardTitle className="text-2xl font-bold text-gray-800">Contact Us</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-semibold text-gray-700">Full Name *</label>
            <Input
              value={formData.fullName}
              onChange={(e) => handleInputChange('fullName', e.target.value)}
              placeholder="Enter your full name"
              className="border-2 border-[#f91bdc]/30 focus:border-[#f91bdc]"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-semibold text-gray-700">Email Address *</label>
            <Input
              type="email"
              value={formData.emailAddress}
              onChange={(e) => handleInputChange('emailAddress', e.target.value)}
              placeholder="Enter your email address"
              className="border-2 border-[#f91bdc]/30 focus:border-[#f91bdc]"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-semibold text-gray-700">Phone Number</label>
            <Input
              type="tel"
              value={formData.phoneNumber}
              onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
              placeholder="Enter your phone number"
              className="border-2 border-[#f91bdc]/30 focus:border-[#f91bdc]"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-semibold text-gray-700">Message *</label>
            <Textarea
              value={formData.message}
              onChange={(e) => handleInputChange('message', e.target.value)}
              placeholder="Enter your message..."
              rows={4}
              className="border-2 border-[#f91bdc]/30 focus:border-[#f91bdc] resize-none"
            />
          </div>

          <Button 
            onClick={handleSend}
            className="w-full bg-[#f91bdc] hover:bg-[#e016c7] text-white py-3 rounded-lg font-semibold"
          >
            Send Message
          </Button>
        </CardContent>
      </Card>
      </div>

      {/* Success Modal */}
      <SuccessModal
        isOpen={showSuccess}
        onClose={() => {
          setShowSuccess(false);
          handleClose();
        }}
        type="contactSent"
      />
    </>
  );
}